// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7a9e538b","335":"90b934ec","377":"31524812"}[chunkId] + ".chunk.js";
};